<template>
    <div>
        <div class="kgr-inputAddon">
            <kgr-input
                class="kgr-inputAddon__input"
                type="text"
                :value="convertedValue"
                :is-invalid="isInvalid"
                :max-length="maxLength"
                @change="handleEvents('change', $event)"
                @input="suppress"
                @post-input="suppress"
            />
            <div class="kgr-inputAddon__addon">
                {{ currency }}
            </div>
        </div>

        <div
            v-if="errorMessageShow"
            class="kgr-color kgr-color--error"
        >
            {{ errorMessageShow }}
        </div>
    </div>
</template>

<script>
import Input from './Input';
import Money from '../../../../js/dto/Money';

export default {
    components: {
        'kgr-input': Input,
    },
    props: {
        value: {
            type: Money,
            required: false,
        },
        currency: {
            type: String,
            required: false,
            default: 'EUR',
        },
        maxLength: {
            type: Number,
            required: false,
            default: 10,
        },
        error: {
            type: String,
            required: false,
        },
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isInvalid: false,
            errorMessage: null,
            invalidValue: null,
            emptyMessage: this.$t('Bitte Betrag eingeben'),
            invalidMessage: this.$t('Ungültiges Format'),
        }
    },
    computed: {
        convertedValue() {
            if (null !== this.invalidValue) {
                return this.invalidValue;
            }

            if(null === this.value) {
                return '';
            }

            return this.value.toLocalizedString();
        },
        errorMessageShow() {
            return this.isInvalid || this.error ? (this.errorMessage || this.error) : null;
        }
    },
    methods: {
        suppress() {
            return null;  //do nothing to avoid emitting @input to parent
        },
        handleEvents(eventName, value) {
            if(value === null || value.trim() === '') {
                if(this.required) {
                    this.errorMessage = this.emptyMessage; //failed to to this via `computed`
                    this.emitError('');
                    return;
                }
                this.emitInput(null);
                return;
            }
            value = value.trim();

            if (Money.isValidLocalizedString(value, this.currency)) {
                this.emitInput(Money.fromLocalizedString(value, this.currency));
                this.errorMessage = null;
            } else {
                this.errorMessage = this.invalidMessage;
                this.emitError(value)
            }
        },
        emitInput(value) {
            this.isInvalid = false;
            this.invalidValue = null;

            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
        emitError(value) {
            this.isInvalid = true;
            this.invalidValue = value;
            this.$emit('error', this.errorMessage);
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
